export default function Trophy() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0039 18V15M18.25 4.75H19.25C20.3546 4.75 21.25 5.64543 21.25 6.75V7.25C21.25 8.90685 19.9069 10.25 18.25 10.25M18.25 4.75V9.25C18.25 12.5637 15.5637 15.25 12.25 15.25H11.75C8.43629 15.25 5.75 12.5637 5.75 9.25V4.75M18.25 4.75C18.25 3.64543 17.3546 2.75 16.25 2.75H7.75C6.64543 2.75 5.75 3.64543 5.75 4.75M5.75 4.75H4.75C3.64543 4.75 2.75 5.64543 2.75 6.75V7.25C2.75 8.90685 4.09315 10.25 5.75 10.25M8.5 21.25H15.5C16.4665 21.25 17.25 20.4665 17.25 19.5C17.25 18.5335 16.4665 17.75 15.5 17.75H8.5C7.5335 17.75 6.75 18.5335 6.75 19.5C6.75 20.4665 7.5335 21.25 8.5 21.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  )
}
